import { render, staticRenderFns } from "./NotificationsCenterCard.vue?vue&type=template&id=6f152039&scoped=true&"
import script from "./NotificationsCenterCard.vue?vue&type=script&lang=ts&"
export * from "./NotificationsCenterCard.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsCenterCard.vue?vue&type=style&index=0&id=6f152039&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f152039",
  null
  
)

export default component.exports